import "../App.css";
import { Container } from "react-bootstrap";
import { CiHome } from "react-icons/ci"; // example icon

const MegaServiceMenu = ({ show, onClose }) => {
  // Data for the first column (all rows of first column)
  const firstColumnData = [
    { heading: "AI/ML", icon: CiHome },
    { heading: "Software Developement", icon: CiHome },
    { heading: "Devops",  icon: CiHome },
    { heading: "Machine Learning",  icon: CiHome },
    { heading: "Web Development",  icon: CiHome },
    { heading: "App Development",  icon: CiHome }
  ];

  // Data for the remaining columns
  const otherColumnsData = [
    { heading: "Finance", content: "Streamline banking and investment solutions." },
    { heading: "Healthcare", content: "Innovative solutions for hospitals, pharma, wellness." },
    { heading: "Tech", content: "AI, software, IoT, and cloud solutions." },
    { heading: "Manufacturing", content: "Automotive, electronics, industrial solutions." },
    { heading: "Investment", content: "Optimized solutions for financial growth." },
    { heading: "Wellness", content: "Healthcare and wellness solutions." }
  ];

   const lastColumnData = [
    { heading: "AI/ML", content: "Streamline banking and investment solutions.", icon: CiHome },
    { heading: "Machine Learning", content: "Streamline banking and investment solutions.",  icon: CiHome },
  ];
  if (!show) return null;

  return (
    <Container>
      <div className="mega-menu" onMouseLeave={onClose}>
        <h4 className="text-dark m-3 ">Our Services</h4>
        <p className="text-dark m-3">
          Working with large datasets requires speed, accuracy, and security—and this platform delivers all three.
        </p>
        <hr className="gradient-line" />

      <Container>
          <div className="row">
          {/* First column */}
          <div className="col-md-3">
            {firstColumnData.map((item, index) => (
              <div
                key={index}
                className="p-1 mb-2 text-light"
              >
               
                <div className="d-flex mb-3">
               <div className="">
  {item.icon && (
    <item.icon
      size={40}
      className="me-4"
      style={{
        background: "linear-gradient(145deg, #d4197a, #7c2ae8)",
        borderRadius: "50%",
        padding: "8px",
        color: "#fff"
      }}
    />
  )}
</div>

                <div><h5 className="mt-1 ms-4 text-dark">{item.heading}</h5></div>
                </div>
             
              </div>
            ))}
          </div>

          
          {/* Remaining columns */}
          <div className="col-md-6">
            <h4 style={{color: "#d4197a"}}>Solutions</h4>
            <div className="row">
              {otherColumnsData.map((item, index) => (
                <div className="col-md-6 mb-3" key={index}>
                  <div
                    className="p-3 h-100 text-light"
                    style={{ minHeight: "120px"}}
                  >
                    <h5 className="mb-2 text-dark">{item.heading}</h5>
                    <p className="mb-0 text-dark" style={{ fontSize: "14px", lineHeight: "1.5rem" }}>
                      {item.content}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
           {/* Last column */}
        {/* Last column */}
       
            <div className="col-md-3 mb-3">
                 <h4 className="mb-4" style={{color: "#d4197a"}}>Engagement Models</h4>
            
     <p className="text-dark mb-4">Streamline banking and investment solutions.</p>
              {lastColumnData.map((item, index) => (
                <div
                  key={index}
                  className="mega-menu-card p-2 mb-4"
                >
                  <div className="d-flex align-items-start">
                    {/* Icon */}
                    <div
                      className="align-self-center d-flex justify-content-center align-items-center"
                      style={{
                        background: "linear-gradient(145deg, #d4197a, #7c2ae8)",
                        borderRadius: "10px",
                        width: "40px",
                        height: "40px",
                        flex: "0 0 54px",
                      }}
                    >
                      {item.icon && <item.icon size={23} color="black" />}
                    </div>

                    {/* Text */}
                    <div className="ms-3">
                      <h5 className="mega-menu-title mb-1 text-dark">{item.heading}</h5>
                      <p
                        className="mega-menu-description mb-0 text-dark"
                        style={{ fontSize: "15px" }}
                      >
                        {item.content}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
        </div>
      </Container>
      </div>
    </Container>
  );
};

export default MegaServiceMenu;
